import { EventEmitter, Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';

@Injectable({
  providedIn: 'root'
})

export class ContentService {

  loggedUserId: any;
  sideMenuChange: any = new EventEmitter();
  count: any = new EventEmitter();
  resourceCount: any = new EventEmitter();
  countManagement: any = new EventEmitter();
  countCareer: any = new EventEmitter();
  sidebarMenu: any = new EventEmitter();

  constructor(
    private socket: Socket
  ) {
    this.loggedUserId = sessionStorage.getItem('id');
  }

  emitSideMenuChangeEvent(value: any) {
    this.sideMenuChange.emit(value);
  }

  getSideMenuChangeEmitter() {
    return this.sideMenuChange;
  }

  emitPRCountEvent() {
    this.socket.on("getPRCount", (data, req) => {
      this.count.emit(data['data']);
    })
  }

  emitResourceCountEvent() {
    this.socket.on("getResourceCount", (data, req) => {
      this.resourceCount.emit(data['data']);
    })
  }

  getPRCountEmitter() {
    return this.count;
  }

  getResourceCountEmitter() {
    return this.resourceCount;
  }

  getAllCount() {
    this.socket.emit("getManagementChildMenuCount");
    this.socket.emit("getCareerChildMenuCount");
    this.socket.on("getManagementChildMenuCount", (data) => {
      this.countManagement.emit(data);
    });
    this.socket.on("getCareerChildMenuCount", (data) => {
      this.countCareer.emit(data);
    });
  }

  getManagementChildCountEmitter() {
    return this.countManagement;
  }

  getCareerChildCountEmitter() {
    return this.countCareer;
  }

  sendMyRequest() {
    this.socket.emit("my-pr-request", "REQUESTED")
    this.socket.on("my-pr-request", (data) => {
      if (data) {
        this.getPRCount();
      }
    })
  }

  sendResourceRequest() {
    this.socket.emit("my-resource-request", "REQUESTED")
    this.socket.on("my-resource-request", (data) => {
      if (data) {
        this.getResourceCount();
      }
    })
  }

  async getPRCount() {
    await this.socket.emit("getPRCount", this.loggedUserId)
    this.emitPRCountEvent();
  }

  async getResourceCount() {
    await this.socket.emit("getResourceCount", this.loggedUserId)
    this.emitResourceCountEvent();
  }

  async getSidebarById() {
    await this.socket.emit("getSidebarById", this.loggedUserId)
    this.socket.on("getSidebarById", (data, req) => {
      this.sidebarMenu.emit(data);
    })
  }
}